module.exports = __webpack_public_path__ + "media/images/guideline/C03-8ce2f4b123fc13e08896e199b184a6d6.jpg";